import React, { FC } from "react";
import { IListing } from "repoV2/features/Listing/Listing.interfaces";
import { IExpressInterestCustomQuestions } from "./IExpressInterestCustomQuestions";
import QuestionInput from "./components/QuestionInput";
import useCustomQuestions from "./useCustomQuestions";

const ExpressInterestCustomQuestions: FC<IExpressInterestCustomQuestions.IProps> =
    props => {
        const { questions, getInputProps } = useCustomQuestions(props);

        return (
            <>
                {questions.map((item: IListing.IQuestion, index: number) => (
                    <QuestionInput {...getInputProps(item, index)} />
                ))}
            </>
        );
    };

export default ExpressInterestCustomQuestions;
